import { useState } from 'react';
import { handleTrack } from '../../../../../../utils/tracker';
import { Button } from '../../../../../Atoms/Button';
import { MarktechModal } from '../../../../../Atoms/Modal';
import { usePartnerPageContext } from '../../../../context';
import { SectionHeader } from '../../../../utils/section-header';
import { PlanCardPartner } from './self-filing-card';
import SelfFilingModal from './self-filing-modal';
import ACCENTURE_PRICING_DATA, { ACCENTURE_SLUG } from '../../../../constants';
import { IPlan } from './types';

interface ISelfItrPlans {
  heading: string;
  description: string;
  isActive: boolean;
  slug?: string;
}

const headings = [
  'Salary Income Plan',
  'Capital Gains or Rental income Plan',
  'NRI or Foreign Income Plan',
];

const ICONS_MAP = [
  'https://assets.clear.in/cleartax/images/1746711749_salaryincome2.svg',
  'https://assets.clear.in/cleartax/images/1746723015_capitalgain.svg',
  'https://assets.clear.in/cleartax/images/1746723263_foreignincome.svg',
];

export const SelfItrPlans: React.FC<ISelfItrPlans> = ({
  heading,
  description,
  isActive,
  slug,
}): JSX.Element => {
  const planData = usePartnerPageContext();
  const isAccenture = slug === ACCENTURE_SLUG;
  const { selfITRPlansData } = isAccenture
    ? ACCENTURE_PRICING_DATA
    : (planData as { selfITRPlansData: IPlan[] });
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const indexModal = isAccenture ? [0, 5, 10] : [0, 6, 11];
  if (!isActive) return <></>;
  return (
    <div className="py-20 sm:pb-14 sm:pt-12">
      <SectionHeader
        heading={heading}
        description={description}
        align="left"
        ctaLink="/filing?&utm_ref=itr_partner_page"
        ctaText="Start Filing"
      />
      <div className="flex justify-between sm:flex-col">
        {selfITRPlansData
          ?.filter(
            (_, index: number) =>
              index === indexModal[0] ||
              index === indexModal[1] ||
              index === indexModal[2]
          )
          .map((plan: IPlan, mapIndex: number) => (
            <PlanCardPartner
              key={mapIndex}
              plan={plan}
              setShowModal={setShowModal}
              index={indexModal[mapIndex]}
              setCurrentIndex={setCurrentIndex}
              heading={headings[mapIndex]}
              icon={ICONS_MAP[mapIndex]}
            />
          ))}
      </div>
      <MarktechModal
        open={showModal}
        closeIcon={'✕'}
        onClose={() => setShowModal(false)}
        classNames={{
          modal: 'rounded-lg mobile-search-box mobile-bottom-fixed pt-5 mt-5',
        }}
        center
      >
        <SelfFilingModal
          plans={selfITRPlansData}
          currentIndex={currentIndex}
          slug={slug}
        />
      </MarktechModal>
      <div className="hidden sm:block text-center font-medium text-s-20 leading-snug">
        <div className="pb-4">
          Start filing for <strong>FREE</strong> & apply the{' '}
          <strong>COUPON</strong> during checkout.
        </div>
        <a
          href={'/filing?&utm_ref=itr_partner_page'}
          rel="noreferrer"
          className="text-white"
          onClick={(e) => handleTrack({ label: 'self_itr', obj: e.target })}
        >
          <Button className="px-14 py-3 bg-blue-350 sm:ml-0 rounded-sm sm:my-2 ml-2 sm:w-full">
            Start filing
          </Button>
        </a>
      </div>
    </div>
  );
};
